// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
window.youtubePlayers = [];
window.onYouTubeIframeAPIReady = () => {
	// console.log('yt ready woe!');
	// Youtube videos
	$('.yt-video-trigger').on('click', function (e) {
		e.preventDefault();
		const $previewContainer = $(this).closest('.yt-video-preview');
		const $videoContainer = $previewContainer.closest('.video-container');
		const videoId = $videoContainer.data('youtube-id');
		// console.log($previewContainer, $videoContainer);
		const options = {
			width: Math.round($videoContainer.width()),
			height: Math.round($videoContainer.height()),
			videoId,
			events: {
				onReady: (event) => event.target.playVideo(),
				onStateChange: (event) => {
					wrapper = event.target.a.offsetParent;
					if (event.data == 1) {
						wrapper.classList.add('yt-player-playing');
					} else {
						wrapper.classList.remove('yt-player-playing');
					}
				}
			}
		};
		const player = new YT.Player($previewContainer[0], options);
		window.youtubePlayers.push(player);
	});
};
